const PAGE_SIZE = 20;

export {
  PAGE_SIZE
};